import { Avatar } from '@eventbrite/eds-avatar';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { LISTING_HEAP_PAGE_AREA_IDS } from '../../../../constants';
import { FollowButton } from '../../FollowButton';
import { useFollowCount } from '../../FollowButton/FollowButton';
import {
    OrganizerStats,
    StyleTypes,
} from '../../OrganizerStats/OrganizerStats';
import { calculateTopOffset, getTrustSignalText } from '../helperFunctions';
import { OrganiserListingPageProps } from '../OrganiserListingPage/OrganiserListingPage';
import { OrganiserListingPageVariantAProps } from '../OrganiserListingPageVariantA/OrganiserListingPageVariantA';
import './OrganiserListingPageVariantB.scss';

export const OrganiserListingPageVariantB = ({
    organizerName,
    organizerAvatar,
    organizerId,
    pageArea,
    style = StyleTypes.CONDENSED_FULL_WIDTH,
    numberOfEvents,
    timeframeInMonths,
}: OrganiserListingPageVariantAProps & OrganiserListingPageProps) => {
    const followersCount = useFollowCount();

    const trustSignalText = getTrustSignalText(
        Number(numberOfEvents),
        Number(timeframeInMonths),
    );
    let renderFollowersCount = false;
    if (followersCount && followersCount > 9) {
        renderFollowersCount = true;
    }

    const mobilecssForTrustSignal = trustSignalText
        ? 'change-image-size-all-variant'
        : 'change-image-size-variantb-no-events';
    const cssForNoFollowers = renderFollowersCount
        ? ''
        : 'organizer-listing-info-variant-b__no-followers';

    const isMobile = calculateTopOffset();

    const renderFollowButtonSection = () => (
        <div className="organizer-listing-info-variant-b__follow">
            <FollowButton
                pageArea={
                    pageArea || LISTING_HEAP_PAGE_AREA_IDS.SIMPLIFIED_ORGANIZER
                }
            />
        </div>
    );

    const renderTrustSignal = () => (
        <div className="organizer-listing-info-variant-b_total-events organizer-listing-info-variant-b_total-events-variantB">
            {trustSignalText}
        </div>
    );

    const renderOrganiserStat = () => (
        <OrganizerStats
            organizer={{ id: organizerId }}
            followersCount={followersCount || null}
            style={style}
        />
    );

    return (
        <section
            className="organizer-listing-info-variant-b"
            aria-label="Organizer profile"
        >
            <div
                className={`organizer-listing-info-variant-b__profile
                    ${isMobile ? `row-image` : 'reverse-image'}`}
            >
                {organizerAvatar &&
                    (isMobile ? (
                        <>
                            <div
                                className={`${mobilecssForTrustSignal} ${cssForNoFollowers}`}
                            >
                                <Avatar imageUrl={organizerAvatar} />
                                <div className="organizer-listing-info-variant-b__followers">
                                    {renderOrganiserStat()}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="organizer-listing-info-variant-b__avatar">
                            <Avatar imageUrl={organizerAvatar} />
                        </div>
                    ))}

                <div
                    className="organizer-listing-info-variant-b__details"
                    data-testid="organizer-info-details"
                >
                    {organizerName && (
                        <span
                            className={
                                isMobile
                                    ? 'organizer-listing-info-variant-b__name-by'
                                    : 'organizer-listing-info-variant-b__name-by include-center'
                            }
                        >
                            {/* Translators: Word "By" followed by the organizer's name, ex: By My Cool Organizer Name */}
                            {gettext('By')}{' '}
                            <strong className="organizer-listing-info-variant-b__name-link">
                                {organizerName}
                            </strong>
                        </span>
                    )}
                    {!isMobile ? (
                        <div className="organizer-listing-info-variant-b_followers-event">
                            {renderOrganiserStat()}

                            {trustSignalText && renderFollowersCount && (
                                <div
                                    className="organizer-listing-info-variant-b-line-size"
                                    aria-hidden="true"
                                ></div>
                            )}

                            {trustSignalText && renderTrustSignal()}
                        </div>
                    ) : (
                        <>
                            {trustSignalText && renderTrustSignal()}
                            {renderFollowButtonSection()}
                        </>
                    )}
                </div>
            </div>

            {!isMobile && renderFollowButtonSection()}
        </section>
    );
};
